import { API_BASE_URL } from "../env";

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly body: unknown,
    message?: string,
  ) {
    super(message ?? `API ${status}`);
  }
}

export interface ApiInit extends RequestInit {
  json?: unknown;
}

export async function apiFetch<T = unknown>(
  path: string,
  init: ApiInit = {},
): Promise<T> {
  const { json, headers, ...rest } = init;
  const url = `${API_BASE_URL}${path}`;

  const finalHeaders = new Headers(headers);
  const body = json !== undefined ? JSON.stringify(json) : rest.body;
  if (json !== undefined && !finalHeaders.has("content-type")) {
    finalHeaders.set("content-type", "application/json");
  }

  const res = await fetch(url, {
    credentials: "include",
    ...rest,
    headers: finalHeaders,
    body,
  });

  const contentType = res.headers.get("content-type") ?? "";
  const parsed: unknown = contentType.includes("application/json")
    ? await res.json().catch(() => null)
    : null;

  if (!res.ok) throw new ApiError(res.status, parsed, `API ${res.status}`);
  return parsed as T;
}
